import React from "react";
import { useLang } from "@/contexts/LangContext";
import MotionReveal from "@/components/MotionReveal";
import AddToCalendarButton from "@/components/AddToCalendarButton";

const Schedule = () => {
  const { t, dict } = useLang();
  return (
    <div data-testid="schedule-page">
      <section className="mx-auto max-w-[1180px] px-5 sm:px-8 pt-24 sm:pt-32">
        <MotionReveal>
          <p className="editorial-kicker">{t("schedule.overline")}</p>
        </MotionReveal>
        <MotionReveal delay={0.05}>
          <h1 className="editorial-h1 mt-6 text-4xl sm:text-6xl lg:text-7xl max-w-[18ch]">
            {t("schedule.title")}
          </h1>
        </MotionReveal>
        <MotionReveal delay={0.1}>
          <p className="mt-8 text-foreground/75 max-w-[52ch] leading-relaxed">{t("schedule.intro")}</p>
        </MotionReveal>
        <MotionReveal delay={0.15}>
          <div className="mt-8">
            <AddToCalendarButton variant="ghost" />
          </div>
        </MotionReveal>
      </section>

      <section className="mx-auto max-w-[1180px] px-5 sm:px-8 mt-16 sm:mt-24" data-testid="schedule-timeline">
        <ol className="relative pl-6 sm:pl-10 border-l border-border">
          {dict.schedule.items.map((it, i) => (
            <MotionReveal key={it.title} delay={0.06 * i}>
              <li className="relative py-8 sm:py-12">
                <span
                  aria-hidden="true"
                  className="absolute -left-[30px] sm:-left-[48px] top-10 w-3 h-3 sm:w-4 sm:h-4 rounded-full bg-background border border-accent"
                />
                <p className="editorial-kicker text-accent">{it.time}</p>
                <h3 className="font-serif-display text-3xl sm:text-4xl mt-3">{it.title}</h3>
                <p className="mt-2 text-foreground/65 italic font-serif-display text-xl">{it.place}</p>
                <p className="mt-4 text-foreground/75 leading-relaxed max-w-[52ch]">{it.note}</p>
              </li>
            </MotionReveal>
          ))}
        </ol>
      </section>

      <section className="mx-auto max-w-[1180px] px-5 sm:px-8 mt-16 sm:mt-24" data-testid="schedule-map">
        <MotionReveal>
          <a
            href="https://maps.app.goo.gl/bBN2GFpLR1yZ1dh99?g_st=ac"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="schedule-map-link"
            className="group block surface-card overflow-hidden hover:shadow-[0_18px_50px_rgba(31,31,31,0.10)] transition-shadow"
          >
            <div className="relative aspect-[16/9] w-full">
              <iframe
                title="Ammos Kalambouri Beach map"
                src="https://www.google.com/maps?q=Ammos+Kalambouri+Beach,+Pegeia,+Cyprus&hl=en&z=15&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="absolute inset-0 w-full h-full border-0 pointer-events-none group-hover:pointer-events-auto"
                allowFullScreen
              />
            </div>
            <div className="p-6 flex items-center justify-between gap-4 border-t border-border">
              <div>
                <p className="editorial-kicker text-accent">{t("schedule.mapCaption")}</p>
                <p className="font-serif-display text-xl mt-1">
                  Pegeia, Cyprus
                </p>
              </div>
              <span className="text-[11px] tracking-[0.22em] uppercase text-foreground/60 group-hover:text-accent transition-colors underline decoration-accent/40 underline-offset-4 whitespace-nowrap">
                {t("schedule.mapOpen")}
              </span>
            </div>
          </a>
        </MotionReveal>
      </section>

      <section className="mx-auto max-w-[1180px] px-5 sm:px-8 mt-20 sm:mt-28 pb-12">
        <MotionReveal>
          <p className="editorial-kicker">{t("schedule.dressOverline")}</p>
        </MotionReveal>
        <MotionReveal delay={0.05}>
          <h3 className="editorial-h2 mt-4 text-3xl sm:text-5xl max-w-[18ch]">
            {t("schedule.dressTitle")}
          </h3>
        </MotionReveal>
        <MotionReveal delay={0.1}>
          <p className="mt-6 text-foreground/75 leading-relaxed max-w-[52ch]">{t("schedule.dressBody")}</p>
        </MotionReveal>
      </section>
    </div>
  );
};

export default Schedule;
